import styles from "./CreateAlbumPictureRow.module.css";
import { CreateAlbumPictureSquare } from "./CreateAlbumPictureSquare";

export const CreateAlbumPictureRow = ({ pictures = [], removeByID }) => {
  while (pictures.length < 5) {
    pictures.push(null);
  }
  return (
    <>
      <div className={styles.album_single_square_picture_div}>
        {Array.isArray(pictures) &&
          pictures.length > 0 &&
          pictures.map((picture, index) => (
            <CreateAlbumPictureSquare
              key={index}
              picture={picture}
              removeByID={removeByID}
            />
          ))}
      </div>
    </>
  );
};
